import {
    PREVIEW_REQUEST_REPORT_SUCCESS,
    PREVIEW_REQUEST_REPORT_FAILURE, 
    PREVIEW_REQUEST_REPORT_CLEAR, 
    CREATE_REQUEST_REPORT_SUCCESS, 
    CREATE_REQUEST_REPORT_CLEAR, 
    CREATE_REQUEST_REPORT_FAILURE, 
    FlightRequestReportActionTypes,
    FLIGHT_REQUEST_REPORT_LIST_SUCCESS,
    FLIGHT_REQUEST_REPORT_LIST_FAILURE,
    FlightRequestReportsListState
} from "./types"

export function previewFlightRequestReport(state = {}, action: FlightRequestReportActionTypes) {
    switch (action.type) {
        case PREVIEW_REQUEST_REPORT_SUCCESS:
            return action.payload;
        case PREVIEW_REQUEST_REPORT_FAILURE:
            return { error: true };
        case PREVIEW_REQUEST_REPORT_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function createFlightRequestReport(state = {}, action: FlightRequestReportActionTypes) {
    switch (action.type) {
        case CREATE_REQUEST_REPORT_SUCCESS:
            return action.payload;
        case CREATE_REQUEST_REPORT_FAILURE:
            return { error: true };
        case CREATE_REQUEST_REPORT_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

const flightRequestReportssListInitialState: FlightRequestReportsListState = {
    data: [],
    total: 0,
};
export function flightRequestReports(state = flightRequestReportssListInitialState, action: FlightRequestReportActionTypes) {
    switch (action.type) {
        case FLIGHT_REQUEST_REPORT_LIST_SUCCESS:
            return action.payload.data;
        case FLIGHT_REQUEST_REPORT_LIST_FAILURE:
            return action.payload;
        default:
            return state;
    }
}